export default {
  title: 'Panorama-Restaurant in Valdobbiadene | Osteria alla Terrazza',
  titleMenu: 'Traditionelle Veneto-Speisekarte | Osteria alla Terrazza',
  titleWine: 'Weinkarte Prosecco Valdobbiadene | Osteria alla Terrazza',
  description:
    'Restaurant an der Prosecco-Weinstraße mit regionaler Küche, DOCG Prosecco, Aperitif und Blick auf die UNESCO-Hügel.',
  descriptionWine:
    'Weinkarte mit Valdobbiadene Prosecco und regionaler Auswahl: glasweise oder flaschenweise, mit Empfehlungen, die die Aromen der traditionellen Küche unterstreichen.',
  descriptionMenu:
    'Saisonale Speisekarte der traditionellen Küche aus Venetien: Vorspeisen, Pasta und Hauptgerichte, lokale Zutaten und Tagesgerichte mit Blick auf die Weinberge.',
}
